import React, { Component } from 'react';
import './App.css';
import { Nav } from './components/Nav';
import { Home } from './pages/Home';
import { Footer } from './components/Footer';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { FourOhFour } from './pages/FourOhFour';
import { Conduct } from './pages/Conduct';
import { Contributing } from './pages/Contributing';

class App extends Component {
  render() {
    return (
      <HashRouter basename={process.env.PUBLIC_URL}>
        <div className="main-content-container">
          <Nav />
          <div className="body-content">
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/contributing" component={Contributing} />
              <Route exact path="/conduct" component={Conduct} />
              <Route component={FourOhFour} />
            </Switch>
            <Footer />
          </div>
        </div>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js